// Charbonier Studio — Grilles publiques « Mise en page & édition »
// Source de vérité : le configurateur `/mise-en-page` (EditionConfigurator.jsx).
// Ces cartes s'affichent sur `/services` (Découvrir les prestations) et `/tarifs`
// et pointent toutes vers le configurateur avec présélection via ?type=...

export const EDITION_FORMULAS = [
  {
    type: "text",
    name: "Mise en page — livre essentiellement texte",
    desc: "Roman, essai, récit ou ouvrage principalement composé de texte.",
    formula: [
      { line: "149 € jusqu'à 1 000 caractères", highlight: true },
      { line: "+1,25 € par tranche de 1 000 caractères supplémentaires à partir du 1 001e caractère" },
    ],
    note: "Calcul selon le nombre de caractères espaces compris.",
  },
  {
    type: "structured",
    name: "Mise en page — livre structuré",
    desc: "Livre comprenant plusieurs niveaux de titres, citations, notes, encadrés, listes ou tableaux simples.",
    formula: [
      { line: "179 € jusqu'à 1 000 caractères", highlight: true },
      { line: "+1,50 € par tranche de 1 000 caractères supplémentaires à partir du 1 001e caractère" },
    ],
    note: "Calcul selon le nombre de caractères espaces compris.",
  },
  {
    type: "illustrated",
    name: "Mise en page — livre illustré",
    desc: "Livre associant texte et illustrations, photographies ou autres éléments visuels.",
    formula: [
      { line: "179 € jusqu'à 1 000 caractères", highlight: true },
      { line: "+1,50 € par tranche de 1 000 caractères supplémentaires" },
      { line: "+7 € par page réellement illustrée" },
    ],
    note: "Une page uniquement textuelle ne génère aucun supplément illustration.",
  },
  {
    type: "magazine",
    name: "Mise en page — magazine / revue",
    desc: "À partir d'une maquette éditoriale déjà existante.",
    formula: [
      { line: "18 € / page", highlight: true },
    ],
    note: "La maquette de votre publication doit déjà exister. Vous n'avez pas encore de maquette ? Choisissez « Nouvelle maquette + mise en page ».",
  },
  {
    type: "magazine_new",
    name: "Nouvelle maquette + mise en page magazine / revue",
    desc: "Création de l'identité éditoriale et mise en page complète de la publication.",
    formula: [
      { line: "199 € de création de maquette", highlight: true },
      { line: "18 € / page" },
    ],
    note: "Total calculé automatiquement selon le nombre de pages.",
  },
  {
    type: "brochure",
    name: "Brochure / livret",
    desc: "Document multipage assemblé : livret, brochure, plaquette multipage…",
    formula: [
      { line: "99 € de base", highlight: true },
      { line: "12 € / page" },
    ],
    note: "Pour un flyer ou un dépliant constitué d'une seule feuille pliée, utilisez « Créer mon support ».",
  },
];

export const editionConfiguratorHref = (type) => `/mise-en-page?type=${encodeURIComponent(type)}`;
